import { CommonEnums } from '../../../app/shared/common.enums';

export class TCmd_Inst {

    tCmd_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    tCmdScriptPath: string;
    tCmdScriptNm: string;
    valid_Cd: string;
    dxFlow_Id: number;
    flagent_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    agentGrpInd: string;
    disableFlg: string;
    success_Codes: string;
    tCmdType: string;
    flagentNm: string;
    conn_Id: number;
    tCmdScriptValid_Cd: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {

        this.tCmd_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.tCmdScriptPath = CommonEnums.defaults.STRING_EMPTY;
        this.tCmdScriptNm = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.flagent_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.agentGrpInd = CommonEnums.defaults.STRING_EMPTY;
        this.disableFlg = CommonEnums.defaults.STRING_EMPTY;
        this.success_Codes = CommonEnums.defaults.STRING_EMPTY;
        this.tCmdType = CommonEnums.defaults.STRING_EMPTY;
        this.flagentNm = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.tCmdScriptValid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;

    }

    parse(object: TCmd_Inst): TCmd_Inst {
        let _tCmd_Inst = new TCmd_Inst();
        _tCmd_Inst.copyFrom(object as TCmd_Inst)
        return _tCmd_Inst;
    }

    getPrimaryKey(): string {
        return this.tCmd_Inst_Id + '.' + this.dxFlow_Id;
    }

    copy(): TCmd_Inst {
        let tCmd_InstTmp: TCmd_Inst = new TCmd_Inst();

        tCmd_InstTmp.tCmd_Inst_Id = this.tCmd_Inst_Id;
        tCmd_InstTmp.nm = this.nm;
        tCmd_InstTmp.description = this.description;
        tCmd_InstTmp.ver = this.ver;
        tCmd_InstTmp.tCmdScriptPath = this.tCmdScriptPath;
        tCmd_InstTmp.tCmdScriptNm = this.tCmdScriptNm;
        tCmd_InstTmp.valid_Cd = this.valid_Cd;
        tCmd_InstTmp.dxFlow_Id = this.dxFlow_Id;
        tCmd_InstTmp.flagent_Id = this.flagent_Id;
        tCmd_InstTmp.updateBy = this.updateBy;
        tCmd_InstTmp.lastUpdateBy = this.lastUpdateBy;
        tCmd_InstTmp.updateDt = this.updateDt;
        tCmd_InstTmp.agentGrpInd = this.agentGrpInd;
        tCmd_InstTmp.disableFlg = this.disableFlg;
        tCmd_InstTmp.success_Codes = this.success_Codes;
        tCmd_InstTmp.tCmdType = this.tCmdType;
        tCmd_InstTmp.flagentNm = this.flagentNm;
        tCmd_InstTmp.conn_Id = this.conn_Id;
        tCmd_InstTmp.tCmdScriptValid_Cd = this.tCmdScriptValid_Cd;
        tCmd_InstTmp.retryEnabled = this.retryEnabled;
        tCmd_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        tCmd_InstTmp.retryWaitTime = this.retryWaitTime;


        return tCmd_InstTmp;
    }

    copyFrom(tCmd_InstTmp: TCmd_Inst): void {

        this.tCmd_Inst_Id = tCmd_InstTmp.tCmd_Inst_Id;
        this.nm = tCmd_InstTmp.nm;
        this.description = tCmd_InstTmp.description;
        this.ver = tCmd_InstTmp.ver;
        this.tCmdScriptPath = tCmd_InstTmp.tCmdScriptPath;
        this.tCmdScriptNm = tCmd_InstTmp.tCmdScriptNm;
        this.valid_Cd = tCmd_InstTmp.valid_Cd;
        this.dxFlow_Id = tCmd_InstTmp.dxFlow_Id;
        this.flagent_Id = tCmd_InstTmp.flagent_Id;
        this.updateBy = tCmd_InstTmp.updateBy;
        this.lastUpdateBy = tCmd_InstTmp.lastUpdateBy;
        this.updateDt = tCmd_InstTmp.updateDt;
        this.agentGrpInd = tCmd_InstTmp.agentGrpInd;
        this.disableFlg = tCmd_InstTmp.disableFlg;
        this.success_Codes = tCmd_InstTmp.success_Codes;
        this.tCmdType = tCmd_InstTmp.tCmdType;
        this.flagentNm = tCmd_InstTmp.flagentNm;
        this.conn_Id = tCmd_InstTmp.conn_Id;
        this.tCmdScriptValid_Cd = tCmd_InstTmp.tCmdScriptValid_Cd;
        this.retryEnabled = tCmd_InstTmp.retryEnabled;
        this.numOfRetryAttempts = tCmd_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = tCmd_InstTmp.retryWaitTime;

    }

    compare(tCmd_InstTmp: TCmd_Inst): string {
        let tCmd_InstString: string = this.toString(false);
        let tCmd_InstTmpString: string = tCmd_InstTmp.toString(false);

        if (tCmd_InstString != tCmd_InstTmpString) {
            return tCmd_InstString + ', ' + tCmd_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "TCmd_Inst[tCmd_Inst_Id=" + this.tCmd_Inst_Id +
            ",nm=" + this.nm +
            ",description=" + this.description +
            ",ver =" + this.ver +
            ", tCmdScriptPath=" + this.tCmdScriptPath +
            ",tCmdScriptNm=" + this.tCmdScriptNm +
            ",valid_Cd=" + this.valid_Cd +
            ",dxFlow_Id=" + this.dxFlow_Id +
            ",flagent_Id=" + this.flagent_Id +
            ",updateBy=" + this.updateBy +
            ",updateDt=" + this.updateDt +
            ",agentGrpInd=" + this.agentGrpInd +
            ",disableFlg=" + this.disableFlg +
            ",success_Codes=" + this.success_Codes +
            ",tCmdType=" + this.tCmdType +
            ",flagentNm=" + this.flagentNm +
            ",conn_Id=" + this.conn_Id +
            ",tCmdScriptValid_Cd=" + this.tCmdScriptValid_Cd +
            "retryEnabled=" + this.retryEnabled +
            "numOfRetryAttempts=" + this.numOfRetryAttempts +
            "retryWaitTime" + this.retryWaitTime;
        if (isNotCompare) {
            str += ",lastUpdateBy=" + this.lastUpdateBy;
        }

        str += ']';

        return str;
    }
} 
